import { createResource, type RouteResource } from 'react-resource-router';

import type { HeartbeatsResponse, UserRightsResponse } from '../../common/types';
import { getHeartbeatsEndpoint, getHeartbeatsUserRights } from '../endpoints';

export const heartbeatsResource: RouteResource<HeartbeatsResponse> = createResource({
	type: 'heartbeatsResource',
	getKey: (routerContext) => {
		const teamId = routerContext.match.params?.teamId;

		return `heartbeats/${teamId ?? ''}`;
	},
	getData: async (routerContext) => {
		const teamId = routerContext.match.params?.teamId;

		return getHeartbeatsEndpoint(teamId);
	},
	isBrowserOnly: true,
});

export const heartbeatsUserRightsResource: RouteResource<UserRightsResponse> = createResource({
	type: 'heartbeatsUserRightsResource',
	getKey: (routerContext) => {
		const teamId = routerContext.match.params?.teamId;

		return `heartbeats-user-rights/${teamId ?? ''}`;
	},
	getData: async (routerContext) => {
		const teamId = routerContext.match.params?.teamId;

		return getHeartbeatsUserRights(teamId);
	},
	isBrowserOnly: true,
});

export const resources = (): (
	| RouteResource<HeartbeatsResponse>
	| RouteResource<UserRightsResponse>
)[] => [heartbeatsResource, heartbeatsUserRightsResource];
